<template>
  <div class="sidebar sidebar-right">
    <div :class="{ sticky: isSticky }">
      <div>
        <div class="sidebar_title-main">Награды</div>

        <div :id="award.id" class="body_box" v-for="award in getAwardsSnippet">
          <router-link :to="{ path: '/awards', query: { q: award.id }}" class="body_text-plain last link" v-html="award.title"></router-link>

          <div class="award_image-container">
            <router-link :to="{ path: '/awards', query: { q: award.id }}">
              <img class="award_image" :src="award.imagesrc" alt="IMAGE">
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isSticky: false
    };
  },
  computed: {
    getAwardsSnippet() {
      return this.$store.getters.getAwardsSnippet;
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == "/awards" && from.path == "/awards") {
        var elem = to.query.q;

        setTimeout(() => {
          if (elem)
            this.$scrollTo("#" + elem, this.$store.state.scrollTo.options);
        }, 350);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~styles/_vars.scss";

.sticky {
  position: fixed;
  width: $sidebar-width;
}

.award_image-container {
  text-align: center;
}

.award_image {
  padding-top: 1.5rem;
  max-width: 80%;
  height: auto;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// client/components/SidebarRight.vue